export default __webpack_public_path__ + "static/media/weekly_info_icon.46e27645.svg";